import { render } from "./AlerteModal.vue?vue&type=template&id=677a11f9&scoped=true&ts=true&lang=pug"
import script from "./AlerteModal.vue?vue&type=script&lang=ts"
export * from "./AlerteModal.vue?vue&type=script&lang=ts"

import "./AlerteModal.vue?vue&type=style&index=0&id=677a11f9&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-677a11f9"]])

export default __exports__